import styled from 'styled-components';

export const StyledActionsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0;
  height: 50px;
  padding: 8px 0;
  .left-side {
  }
  .right-side {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    & button {
      margin-left: 8px;
    }
  }
`;
